export default class Signature{

    // constructor
    constructor(type,imageUrl,imageFile,isSignatureVerified,verifiedSignatureData) {
        this.type = type; // canvas, upload, text
        this.imageUrl = imageUrl;
        this.imageFile = imageFile;
        this.isSignatureVerified = isSignatureVerified;
        this.verifiedSignatureData = verifiedSignatureData;
    }

    // methods
}